import { useSmoothScroll } from "@/lib/lenis";
import { Navbar } from "@/components/portfolio/Navbar";
import { Hero } from "@/components/portfolio/Hero";
import { About } from "@/components/portfolio/About";
import { Marquee } from "@/components/portfolio/Marquee";
import { Experience } from "@/components/portfolio/Experience";
import { Trailers } from "@/components/portfolio/Trailers";
import { Projects } from "@/components/portfolio/Projects";
import { Skills } from "@/components/portfolio/Skills";
import { Contact } from "@/components/portfolio/Contact";

export default function Portfolio() {
  useSmoothScroll();

  return (
    <div className="relative min-h-screen bg-paper text-ink antialiased overflow-x-hidden">
      <div className="grain-overlay pointer-events-none fixed inset-0 z-[60] opacity-[0.035] mix-blend-multiply" />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Marquee />
        <Experience />
        <Trailers />
        <Projects />
        <Skills />
        <Contact />
      </main>
    </div>
  );
}
